import React from 'react';
import adminStore from '../../storage/AdminStore'
import {observer} from 'mobx-react-lite'
import PhoneInput from 'react-phone-input-2'
import appStore from '../../storage/AppStore'
import ClickableMap from '../../ui/ClickableMap'
import systemStore from '../../storage/SystemStore'
import Btn from "../../ui/Btn";
import MultipleSelect from '../../ui/MultipleSelect'
import Input from '../../ui/Input'
import clubStore from '../../storage/ClubStore'

const AdminCompany = () => {
  
  return (
    <div className="row justify-content-center">
      <h3
        className="text-center pb-2 pb-sm-3 mt-lg-3 mt-xl-4">{adminStore.company.id === 0 ? 'Жаңы компания кошуу' : `№${adminStore.company.id}, ${adminStore.company.name} оңдоо`}</h3>
      <div className={"col-12"}>
        <form className={`needs-validation${clubStore.branch.was_validated ? ' was-validated' : ''}`} noValidate="">
          <div className="row g-4">
            <div className="col-12">
              <label htmlFor="input_phone_number" className="form-label">{appStore.tr.phone_number} *</label>
              <PhoneInput
                country={appStore.user.country_id.toLowerCase() || 'kg'} // Default country
                value={adminStore.company.owner_phone}
                onChange={(phone) => {
                  adminStore.company.setProperty('owner_phone', phone)
                }}
                inputClass="form-control"
              />
            </div>
            <div className="col-12">
              <label htmlFor="input_name" className="form-label">{appStore.tr.name} *</label>
              <Input id={"input_name"} label={appStore.tr.name} store={adminStore.company} prop={'name'}/>
            </div>
            <div className="col-12">
              <label htmlFor="input_address" className="form-label">{appStore.tr.address} *</label>
              <Input label={appStore.tr.address} store={adminStore.company} prop={'address'}/>
            </div>
            <div className="col-12">
              <label htmlFor="input_sports" className="form-label">{appStore.tr.sport_types} *</label>
              <MultipleSelect
                id={"input_sports"}
                placeholder={appStore.tr.please_select}
                label={appStore.tr.sport_types}
                store={adminStore.company}
                prop={'sports'}
                options={appStore.sports}
              />
            </div>
            <div className="col-12">
              <label htmlFor="input_location" className="form-label">{appStore.tr.location} *</label>
              <ClickableMap
                id={"input_location"}
                center={[42.847723378643614, 74.59883964450174]}
                zoom={12}
                store={adminStore.company}
                prop={'location'}
              />
            </div>
            <div className="col-12 text-center pt-2 pb-3">
              <Btn
                className="btn btn-success"
                type="button"
                disabled={!adminStore.company.is_valid}
                onClick={() => {
                  adminStore.saveCompany().then(() => {
                    systemStore.setSuccess(appStore.tr.successfully_saved)
                  }).catch((error) => {
                    systemStore.setError(error.message)
                  })
                }}
              >
                {appStore.tr.add}
              </Btn>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default observer(AdminCompany);